import { Settings } from "@/components/ui/SettingsSection";
import OnboardingSetting from "./OnboardingSetting";

function UserPreferences() {
  return (
    <Settings.Section title="Platform preferences">
      <OnboardingSetting />
    </Settings.Section>
  );
}

export default UserPreferences;
